<template>
  <div class="tac-admin-build-spec">
    <div class="page-header sticky-nav--page-header" v-sticky-nav>
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-gear"></span>
        {{ pageTitle }}
        <span v-if="partNumber">&nbsp;&nbsp;&nbsp;Part # {{ partNumber | NormalizePartNumber }}</span>
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline">
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-primary" @click.prevent="save"        :disabled="fetchingData">Save</button>
                <!-- <button type="button" class="btn btn-default" @click.prevent="saveAndExit" :disabled="fetchingData">Save &amp; Exit</button> -->
              </div><!-- .btn-group -->
              <div class="btn-group">
                <a class="btn btn-default" :href="createOldProductLink(productId)"><i class="fa fa-fw fa-barcode"></i> View Admin Product</a>
              </div><!-- .btn-group -->
              <div class="btn-group">
                <a :href="getLiveProductLink()" title="View Live Product" target="_blank" class="btn btn-default"><i class="fa fa-fw fa-external-link"></i> View Live Product</a>
              </div><!-- .btn-group -->
            </div><!-- .btn-toolbar -->
          </div><!-- .form-group -->
        </div><!-- .form-inline -->
      </div><!-- .page-header-actions -->
    </div><!-- .page-header -->
    <div class="page-body">
      <h4><span v-html="name"></span></h4>
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="clearfix">
            <div class="pull-left">Specs</div>
            <div class="pull-left">
              <a class="text-primary" type="button" @click="addSpec" title="Add Spec"><i class="fa fa-fw fa-plus"></i></a>
            </div>
          </div>
        </div><!-- .panel-heading -->
        <div class="panel-body">
          <div v-for="(spec, specKey) in form.specs" :key="specKey" class="build-spec__specs">
            <div class="panel panel-default">
              <div class="panel-heading">
                <div class="form-inline form-inline--better-spaced build-spec__spec">
                  <div class="form-group form-group-sm">
                    <a class="text-danger" type="button" @click="removeSpec(spec)" title="Remove Spec"><i class="fa fa-fw fa-times"></i></a>
                  </div>
                  <div class="form-group form-group-sm">
                    <label class="sr-only">Status:</label>
                    <toggle class="toggle--input-group-addon" v-model="spec.status" :disabled="fetchingData" title="Toggle Spec Status"></toggle>
                  </div>
                  <div class="form-group form-group-sm build-spec__spec-sort">
                    <label>Sort:</label>
                    <input class="form-control input-sm" type="text" v-model="spec.order" :disabled="fetchingData" />
                  </div>
                  <div class="form-group form-group-sm build-spec__spec-label">
                    <label>Label:</label>
                    <input class="form-control input-sm" type="text" v-model="spec.label" :disabled="fetchingData" />
                  </div>
                  <div class="form-group form-group-sm build-spec__spec-no-selection">
                    <label>No Selection Label:</label>
                    <input class="form-control input-sm" type="text" v-model="spec.noSelection" :disabled="fetchingData" />
                  </div>
                </div>
              </div><!-- .panel-heading -->
              <table class="table table-responsive table-bordered table-compact build-spec__items">
                <thead>
                  <tr>
                    <th class="text-center" style="width: 1rem;"><i class="fa fa-fw fa-th-list"></i></th>
                    <th class="text-center" style="width: 7rem;">Status</th>
                    <th class="text-center" style="width: 7rem;">Sort</th>
                    <th class="text-center" style="width: 12rem;">Type</th>
                    <th class="text-center" style="width: 25rem;" title="Part number or product ID">Type #</th>
                    <th>Label</th>
                    <th style="width: 30rem;">Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!spec.items.length">
                    <td colspan="7" class="text-center">
                      <p>No Item Added</p>
                      <p><button class="btn btn-primary" type="button" @click="addItem(spec)" :disabled="fetchingData">Add Item</button></p>
                    </td>
                  </tr>
                  <tr v-for="(item, itemKey) in spec.items" :key="itemKey" class="build-spec__item">
                    <td class="text-center">
                      <a class="text-danger" type="button" @click="removeItem(spec, item)" title="Remove Item"><i class="fa fa-fw fa-times"></i></a>
                    </td>
                    <td class="text-center">
                      <toggle class="toggle--input-group-addon" v-model="item.status" :disabled="fetchingData" title="Toggle Item Status"></toggle>
                    </td>
                    <td class="text-center build-spec__item-sort">
                      <input type="text" class="form-control input-sm text-center" v-model="item.order" :disabled="fetchingData" />
                    </td>
                    <td class="text-center build-spec__item-type">
                      <select class="form-control input-sm" :value="item.type" @change="updateItemType(spec, item, $event)" :disabled="fetchingData">
                        <option value="part">Part Exact</option>
                        <option value="product">Part Attribute</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <div class="input-group input-group-sm">
                        <span class="input-group-btn">
                          <button
                            class="btn btn-default btn-sm"
                            type="button"
                            @click="searchProduct(spec, item)"
                            title="Search Product"><i class="fa fa-fw fa-search"></i></button>
                          <button
                            class="btn btn-default btn-sm"
                            type="button"
                            title="Product ID"
                            disabled
                            v-if="'product' === item.type"
                            >ID</button>
                        </span>
                        <input
                          type="text"
                          class="form-control input-sm text-center"
                          v-model="item.reference"
                          :disabled="fetchingData"
                          :readonly="'product' === item.type"
                          @keypress.enter.prevent="manuallySearchProduct(spec, item, $event)"
                          />
                        <span class="input-group-btn">
                          <router-link
                            :to="{path: getLinkOfItemToOldProduct(item)}"
                            target="_blank"
                            class="btn btn-default"
                            title="View Product"
                            ><i class="fa fa-fw fa-external-link"></i></router-link>
                        </span>
                      </div>
                    </td>
                    <td class="build-spec__item-label">
                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <textarea class="form-control" title="Custom Label" v-model="item.customLabel"></textarea>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <span v-html="noHtml(item.label)"></span>
                          <ul v-if="getAttributeLabels(item)" class="list-unstyled">
                            <li v-for="(label, key) in getAttributeLabels(item)" :key="key">- {{ label.option | noHtml }}</li>
                          </ul>
                          <ul v-else class="list-unstyled">
                            <li v-for="(choice, cKey) in getChoices(item)" :key="cKey">
                              {{ choice.label }}
                              <ul>
                                <li v-for="(option, oKey) in getOptions(item, choice)" :key="oKey">
                                  {{ option.partNumber }} {{ option.label | noHtml }} [ {{ convertAvailabilityToLabel(option.availability) }} ]
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                    <td class="build-spec__item-note">
                      <textarea class="form-control" title="Note" v-model="item.note"></textarea>
                    </td>
                  </tr>
                  <tr v-if="!!spec.items.length">
                    <td colspan="8">
                      <a class="text-primary" type="button" title="Add Item" @click="addItem(spec)"><i class="fa fa-fw fa-plus"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div><!-- .panel -->
          </div><!-- .build-specs -->
        </div><!-- .panel-body -->
        <div class="panel-footer" v-if="!!form.specs.length">
          <a class="text-primary" type="button" title="Add Spec" @click="addSpec"><i class="fa fa-fw fa-plus"></i></a>
        </div><!-- .panel-footer -->
      </div><!-- .panel -->
    </div><!-- .page-body -->
    <search-product-modal
      v-if="searchProductForm.load"
      :p-default-form="{status: 'allactive'}"
      :show="searchProductForm.show"
      @close="closeSearchProduct"
      @closed="unloadSearchProduct"
      @item-return="applyFoundProduct"
      >
    </search-product-modal>
    <modal
      size="large"
      :show="selectAttributeForm.show"
      :callback="applySelectedAttribute"
      @close="closeSelectAttribute"
      >
      <span slot="title">Select Attribute</span>
      <div slot="content" class="clearfix">
        <form v-on:submit.prevent="applySelectedAttribute">
          <button class="hidden">Required For Listening To Form Submission</button>
          <ul class="list-unstyled">
            <li v-for="(choice, key) in getChoices(selectAttributeForm.item)" :key="key">
              {{ choice.label }}
              <select class="form-control" v-model="selectAttributeForm.attrs[choice.id]">
                <option :value="null"></option>
                <option v-for="(option, key) in getOptions(selectAttributeForm.item, choice)" :key="key" :value="option.partNumber">{{ option.label }}</option>
              </select>
            </li>
          </ul>
        </form>
      </div>
    </modal>
    <vue-progress-bar></vue-progress-bar>
  </div><!-- .tac-admin-build-spec -->
</template>

<script>
import _ from 'lodash'
import uuid from 'uuid/v4'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import AuthMixin from '@/plugin/mixin/auth'
import FormMixin from '@/plugin/mixin/form'
import Modal from '@/plugin/bootstrap/modal';
import NoHtml from '@/plugin/filter/no-html';
import NoHtmlMixin from '@/plugin/mixin/no-html';
import NormalizePartNumber from '@/plugin/filter/normalize-part-number';
import ProductLinkMixin from '@/plugin/mixin/product-link'
import SearchProductModal from '@/plugin/bootstrap/search-product-modal';
import StickyNav from '@/plugin/directive/sticky-nav'
import Toggle from '@/plugin/bootstrap/toggle'
import UrlEncodeObjectMixin from '@/plugin/mixin/url-encode-object'

export default {
  data() {
    return {
      pageTitle: 'Multiple Attribute Config',
      name: '',
      partNumber: '',
      form: {
        specs: []
      },
      searchProductForm: {
        load  : false,
        show  : false,
        result: false,
        spec  : false,
        item  : false
      },
      selectAttributeForm: {
        show : false,
        spec : false,
        item : false,
        type : null,
        attrs: {}
      },
      fetchingData: false
    }
  },
  created() {
    this.$store.dispatch('app/changeTitle', this.pageTitle)
    this.fetch()
  },
  computed: {
    productId() {
      return this.$route.params.id
    }
  },
  methods: {
    fetch() {
      if (this.fetchingData) {
        return
      }

      this.fetchingData = true

      const productId = this.$route.params.id
      this.axios.get(`/admin/product/build-spec/view/${productId}`).then(
        (response) => {
          this.form.specs   = _.get(response, 'data.specs')
          this.name         = _.get(response, 'data.product.genericName')
          this.partNumber   = _.get(response, 'data.product.partNumber')
          this.fetchingData = false
        },
        () => {
          this.fetchingData = false
        }
      )
    },
    getLiveProductLink() {
      const productId = this.$route.params.id

      return `/catalog/product/id-${productId}`
    },
    addSpec() {
      if (this.fetchingData) {
        return
      }

      this.form.specs.push({
        id           : uuid(),
        label        : '',
        noSelection  : '',
        status       : true,
        order        : 0,
        items        : []
      })
    },
    removeSpec(spec) {
      if (this.fetchingData) {
        return
      }

      this.form.specs = _.without(this.form.specs, spec)
    },
    addItem(spec) {
      if (this.fetchingData) {
        return
      }

      spec.items.push({
        id          : uuid(),
        type        : 'part',
        reference   : null,
        label       : '',
        status      : true,
        order       : 0,
        customLabel : '',
        note        : ''
      })
    },
    removeItem(spec, item) {
      if (this.fetchingData) {
        return
      }

      spec.items = _.without(spec.items, item)
    },
    updateItemType(spec, item, ev) {
      const oldVal = item.type
      const newVal = ev.target.value

      if ('part' === oldVal) {
        if ('product' === newVal) {
          item.type      = ev.target.value
          item.reference = item.baseProductId
        }
      }
      if ('product' === oldVal) {
        if ('part' === newVal) {
          this.selectAttribute(spec, item, ev.target.value)
        }
      }
    },
    getItemRouterLinkParams(item) {
      if ('part' === item.type) {
        if (!item.baseProductId) {
          return {}
        }
        return {
          name  : 'admin-product',
          action: 'view',
          params: {
            id: item.baseProductId
          }
        }
      }
      if ('product' === item.type) {
        return {
          name  : 'admin-product',
          action: 'view',
          params: {
            id: item.reference
          }
        }
      }
    },
    searchProduct(spec, item) {
      if (this.fetchingData) {
        return
      }

      this.searchProductForm.spec   = spec
      this.searchProductForm.item   = item
      this.searchProductForm.result = null
      this.searchProductForm.load   = true
      this.searchProductForm.show   = true
    },
    applyFoundProduct(result) {
      if (this.fetchingData) {
        return
      }

      _.assign(this.searchProductForm.result, {
        productId  : _.get(result, 'referenceProductId'),
        inventoryId: _.get(result, 'referenceInventoryId'),
        partNumber : _.get(result, 'partNumber'),
        description: _.get(result, 'description')
      })

      this.updateItemWithNewProduct(this.searchProductForm.item, result)
      this.loadItemNewProductInfo(this.searchProductForm.item)

      this.closeSearchProduct()
    },
    closeSearchProduct() {
      this.searchProductForm.spec   = null
      this.searchProductForm.item   = null
      this.searchProductForm.result = null
      this.searchProductForm.show   = false
    },
    unloadSearchProduct() {
      this.searchProductForm.load = false
    },
    manuallySearchProduct(spec, item, ev) {
      if (this.fetchingData) {
        return
      }

      this.fetchingData = true

      const filters = {
        'part-number': ev.target.value
      }

      this.axios.post('/admin/product/dialog-search', {filters: filters})
      .then((response) => {
        this.updateItemWithNewProduct(item, response.data.items[0])
        this.fetchingData = false
      })
      .catch(() => {
        this.fetchingData = false
      })
    },
    updateItemWithNewProduct(item, product) {
      if ('part' === item.type) {
        item.reference = _.get(product, 'partNumber')
      }
      if ('product' === item.type) {
        item.reference = _.get(product, 'referenceProductId')
      }
      item.label = _.get(product, 'description')
    },
    loadItemNewProductInfo(item) {
      this.fetchingData = false

      const params = {
        type      : item.type,
        reference : item.reference
      }
      this.axios.get(`/admin/product/build-spec/start-new-item`, {params: params})
      .then((response) => {
        const itemData = _.get(response, 'data.item')
        if (itemData) {
          this.$set(item, 'attributes',     _.get(itemData, 'attributes'))
          this.$set(item, 'baseAttributes', _.get(itemData, 'baseAttributes'))
          this.$set(item, 'baseProductId',  _.get(itemData, 'baseProductId'))
          this.$set(item, 'label',          _.get(itemData, 'label'))
          this.$set(item, 'price',          _.get(itemData, 'price'))
        }

        this.fetchingData = false
      })
      .catch(() => {
        this.fetchingData = false
      })
    },
    selectAttribute(spec, item, type) {
      if (this.fetchingData) {
        return
      }

      this.selectAttributeForm.spec  = spec
      this.selectAttributeForm.item  = item
      this.selectAttributeForm.type  = type
      this.selectAttributeForm.show  = true
      this.selectAttributeForm.attrs = {}
    },
    applySelectedAttribute() {
      if (this.fetchingData) {
        return
      }

      const item = _.get(this.selectAttributeForm, 'item')

      const partNumber = _.chain(this.selectAttributeForm)
        .get('attrs')
        .toPairs()
        .first()
        .nth(1)
        .value()

      item.type      = this.selectAttributeForm.type
      item.reference = partNumber

      this.closeSelectAttribute()
    },
    closeSelectAttribute() {
      this.selectAttributeForm.spec  = null
      this.selectAttributeForm.item  = null
      this.selectAttributeForm.type  = null
      this.selectAttributeForm.show  = false
      this.selectAttributeForm.attrs = {}
    },
    getChoices(item) {
      return _.chain(item)
        .get('attributes')
        .map((attr) => {
          return attr.choice
        })
        .uniqBy('id')
        .value()
    },
    getOptions(item, choice) {
      return _.chain(item)
        .get('attributes')
        .filter((attr) => {
          return attr.choice.id === choice.id
        })
        .map((attr) => {
          return _.assign({
            partNumber   : attr.partNumber,
            availability : attr.availability
          }, attr.option)
        })
        .uniqBy('id')
        .value()
    },
    getAttributeLabels(item) {
      if ('part' !== item.type) {
        return null
      }

      return _.chain(item)
        .get('baseAttributes')
        .filter({partNumber: item.reference})
        .map((attr) => {
          return {
            choice: attr.choice.label,
            option: attr.option.label,
          }
        })
        .value()
    },
    convertAvailabilityToLabel(availability) {
      if ('instock' === availability) {
        return 'IN STOCK'
      }
      if (_.includes(['outofstock', 'due', 'backorder'], availability)) {
        return 'OUT OF STOCK'
      }
      return '-'
    },
    saveAndExit() {
      this.save().then(() => {
        this.cancel()
      })
    },
    save() {
      if (this.fetchingData) {
        return
      }

      this.fetchingData = true

      const specs = _.chain(this.form)
        .cloneDeep()
        .get('specs')
        .map((spec) => {
          spec.items = _.chain(spec.items)
            .map((item) => {
              return _.pick(item, [
                'id',
                'type',
                'reference',
                'label',
                'status',
                'order',
                'customLabel',
                'note'
              ])
            })
            .value()

          return _.pick(spec, [
            'id',
            'label',
            'noSelection',
            'status',
            'order',
            'items',
          ])
        })
        .value()

      const data = {
        productId : this.$route.params.id,
        specs     : specs
      }

      return this.axios.post('/admin/product/build-spec/save', data).then(
        response => {
          this.fetchingData = false

          return response
        },
        reason => {
          this.fetchingData = false

          return reason
        }
      ).then(() => {
        return this.fetch()
      })
    },
    getLinkOfItemToOldProduct(item) {
      let productId = null
      if ('part' === item.type) {
        if (item.baseProductId) {
          productId = item.baseProductId
        }
      }
      if ('product' === item.type) {
        if (item.reference) {
          productId = item.reference
        }
      }
      if (!productId) {
        return null
      }
      return this.createOldProductLink(productId)
    },
    reload() {
      this.fetch()
    }
  },
  components: {
    Modal,
    SearchProductModal,
    Toggle
  },
  directives: {
    StickyNav
  },
  filters: {
    NoHtml,
    NormalizePartNumber
  },
  mixins: [
    ApiResponseMixin,
    AuthMixin,
    FormMixin,
    NoHtmlMixin,
    ProductLinkMixin,
    UrlEncodeObjectMixin
  ]
}
</script>
